import { FC } from 'react'
import Link from 'next/link'
import { ICompanyBase } from '@/types'
import { sanitizeUrl } from '@/utils'
import { JobCardList } from '@components-v2/molecules/JobCardList'
import { CompanyCardWithJobHeader } from '@components-v2/molecules/CompanyCardWithJobHeader'
import styles from './index.module.scss'

type Props = {
  company: ICompanyBase
  isHighlightedJobs?: boolean
}

export const CompanyCardWithJob: FC<Props> = ({ company, isHighlightedJobs = false }) => {
  return (
    <div className={styles.container}>
      <Link href={sanitizeUrl(`/companies/${company.slug}`)}>
        <a className={styles.header}>
          <CompanyCardWithJobHeader company={company} />
        </a>
      </Link>
      <div>
        {isHighlightedJobs ? (
          <JobCardList jobs={company.highlightedJobListings?.nodes} />
        ) : (
          <JobCardList jobs={company.jobs?.nodes} />
        )}
      </div>
    </div>
  )
}
